import config from "../config/config";
import AuthService from "./AuthService";

const auth = new AuthService(
  config.AUTH0_API_CLIENT_ID,
  config.AUTH0_API_DOMAIN,
);

export default auth;
